var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.996 511.996",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E21B1B"
    },
    cx: 74.158,
    cy: 183.098,
    r: 29.068
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M106.616,223.79H41.708c-22.92,0.024-41.491,18.595-41.523,41.515v81.416 c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696v-73.014h9.066 v222.839c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696V372.728 h9.05v123.819c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696 V273.692h9.066v73.014c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75 c0.008-0.232,0.008-0.464,0-0.696v-81.4C148.123,242.385,129.544,223.814,106.616,223.79z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E21B1B"
    },
    cx: 437.844,
    cy: 183.098,
    r: 29.068
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E21B1B"
    },
    d: "M470.262,223.79h-64.915c-22.92,0.024-41.499,18.603-41.523,41.523v81.408 c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696v-73.014h9.09 v222.839c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696V372.728 h9.05v123.819c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75c0.008-0.232,0.008-0.464,0-0.696 V273.692h9.066v73.014c-0.192,8.338,6.412,15.254,14.75,15.445c8.338,0.192,15.254-6.412,15.445-14.75 c0.008-0.232,0.008-0.464,0-0.696v-81.4C511.785,242.377,493.19,223.806,470.262,223.79z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.999,215.268h-54.091c-3.406,0-6.164-2.766-6.164-6.164s2.758-6.156,6.164-6.164h54.091 c3.406,0,6.164,2.766,6.164,6.164C289.162,212.51,286.404,215.268,282.999,215.268z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M282.999,232.952h-54.091c-3.406,0-6.164-2.766-6.164-6.164s2.758-6.156,6.164-6.164h54.091 c3.406,0,6.164,2.766,6.164,6.164C289.162,230.194,286.404,232.952,282.999,232.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M226.07,240.371c6.284,10.337,17.82,16.301,29.883,15.453c12.064,0.847,23.6-5.116,29.883-15.453 H226.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M255.961,51.125L255.961,51.125c-52.844,0.048-79.377,53.827-55.082,90.226 c23.064,34.552,21.153,54.139,21.153,54.139h67.873c0,0-1.919-19.611,21.137-54.139C335.339,104.944,308.773,51.165,255.961,51.125 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.985,
    y: 51.109,
    style: {
      fill: "#999999"
    },
    width: 0.024,
    height: 0.024
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M256.009,41.076c-3.406,0-6.164-2.758-6.164-6.164V6.164c0-3.398,2.758-6.164,6.164-6.164 c3.406,0,6.164,2.758,6.164,6.164v0.008v28.78C262.157,38.342,259.407,41.076,256.009,41.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M173.858,135.547h-28.78c-3.406,0-6.164-2.758-6.164-6.164c0-3.406,2.758-6.164,6.164-6.164h0.008 h28.78c3.406,0,6.164,2.758,6.164,6.164C180.029,132.789,177.271,135.547,173.858,135.547 C173.866,135.547,173.866,135.547,173.858,135.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M366.909,135.547h-28.78c-3.406,0-6.164-2.758-6.164-6.164c0-3.406,2.758-6.164,6.164-6.164h0.008 h28.78c3.406,0,6.164,2.758,6.164,6.164C373.081,132.789,370.322,135.547,366.909,135.547 C366.917,135.547,366.917,135.547,366.909,135.547z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M189.207,68.753c-1.639,0-3.206-0.648-4.357-1.807l-20.33-20.338 c-2.342-2.47-2.246-6.372,0.224-8.714c2.382-2.262,6.108-2.262,8.49,0l20.33,20.33c2.414,2.406,2.414,6.308,0.016,8.714 C192.421,68.105,190.854,68.761,189.207,68.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M322.811,68.753c-3.406,0-6.164-2.766-6.164-6.164c0-1.631,0.648-3.198,1.807-4.357l20.33-20.338 c2.342-2.47,6.244-2.566,8.714-0.224c2.47,2.342,2.566,6.244,0.224,8.714c-0.072,0.08-0.144,0.152-0.224,0.224l-20.338,20.33 C326.017,68.097,324.45,68.753,322.811,68.753z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamwork);
export default __webpack_public_path__ + "static/media/teamwork.7825f2361a6dac010ca9dddbd7261c19.svg";
export { ForwardRef as ReactComponent };